
import { defineComponent, PropType, ref } from 'vue'
import { usePackageModule, Package } from '@/modules/packages'
import { PackagesRouteNames } from '@/router/routes-names'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useRouter, useRoute } from 'vue-router'
import usePaginationHelper from '@/views/_shared/search-list/pagination-helper'

export default defineComponent({
    name: 'packages-list',
    props: {
        packages: {
            type: Array as PropType<Package[]>
        }
    },
    setup () {
        const $q = useQuasar()
        const router = useRouter()
        const route = useRoute()
        const { pagination } = usePaginationHelper('code')
        const { deletePackage, activatePackage, deactivatePackage } = usePackageModule()

        const packageColumns = ([
            { name: 'id', label: 'Id', field: 'id', sortable: true, align: 'left' },
            { name: 'code', label: 'Code', field: 'code', sortable: true, align: 'left' },
            { name: 'name', label: 'Name', field: 'name', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const visibleColumns = ref(['code', 'name', 'actions'])

        function onEditPackage (evt: PointerEvent | null, props: Package) {
            router.push({ name: PackagesRouteNames.EDIT, params: { code: props.code }, query: { page: route.query.page } })
        }

        async function onActivatePackage (packageRow: Package) {
            await activatePackage(packageRow.id)
            $q.notify({
                color: 'positive',
                message: 'Package has been activated'
            })
        }

        async function onDeactivatePackage (packageRow: Package) {
            $q.dialog({
                title: 'Deactivate package',
                message: `Are you sure you want to disable package ${packageRow.name}?`,
                cancel: true,
                persistent: true
            }).onOk(() => {
                deactivatePackage(packageRow.id)
                $q.notify({
                    color: 'positive',
                    message: 'Package has been deactivated'
                })
            })
        }

        async function onDeletePackage (packageRow: Package) {
            $q.dialog({
                title: 'Delete package',
                message: `Are you sure you want to remove package ${packageRow.name}?`,
                cancel: true,
                persistent: true
            }).onOk(() => {
                deletePackage(packageRow.id)
                $q.notify({
                    color: 'positive',
                    message: 'Package has been deleted'
                })
            })
        }

        return {
            packageColumns,
            visibleColumns,
            onEditPackage,
            onActivatePackage,
            onDeactivatePackage,
            onDeletePackage,
            pagination
        }
    }
})
